<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM6.92857 6.5C6.92857 5.90826 7.40826 5.42857 8 5.42857C8.59174 5.42857 9.07143 5.90826 9.07143 6.5C9.07143 7.09174 8.59174 7.57143 8 7.57143C7.64496 7.57143 7.35714 7.85925 7.35714 8.21429V8.76841C7.35714 9.12346 7.64496 9.41127 8 9.41127C8.35504 9.41127 8.64286 9.12346 8.64286 8.76841C9.63221 8.48859 10.3571 7.57895 10.3571 6.5C10.3571 5.19819 9.30181 4.14286 8 4.14286C6.69819 4.14286 5.64286 5.19819 5.64286 6.5C5.64286 6.85504 5.93068 7.14286 6.28571 7.14286C6.64075 7.14286 6.92857 6.85504 6.92857 6.5ZM8.85714 11C8.85714 11.4734 8.47339 11.8571 8 11.8571C7.52661 11.8571 7.14286 11.4734 7.14286 11C7.14286 10.5266 7.52661 10.1429 8 10.1429C8.47339 10.1429 8.85714 10.5266 8.85714 11Z"
            fill="#ACB3B9"
        />
    </svg>
</template>

<script>
export default {
    name: 'InfoIcon',
};
</script>
